module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.2 144.2"><path class="st7" stroke="#000" stroke-width=".25" d="M.1.1h240v48H.1z"/><path class="st13" fill="#fab31e" stroke="#000" stroke-width=".25" d="M.1 96.1h240v48H.1z"/><path class="st2" fill="#e40520" stroke="#000" stroke-width=".25" d="M.1 48.1h240v48H.1z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/flag/flg6.svg
// module id = 524
// module chunks = 1